/* zx-cart.js — AJAX add-to-cart for custom product forms.
 * Any <form action="/cart/add"> carrying the data-zx-cart attribute is posted with fetch()
 * and the result is shown in Dawn's cart drawer. Without a drawer, fetch, or on a network
 * error the form submits normally, so adding to cart always works. */
(() => {
  if (window.zxCart) return;

  const errorFor = (form) => {
    let el = form.querySelector('.zx-cart-error');
    if (!el) {
      el = document.createElement('p');
      el.className = 'zx-cart-error';
      el.setAttribute('role', 'alert');
      form.append(el);
    }
    return el;
  };

  const setBusy = (button, busy) => {
    if (!button) return;
    button.toggleAttribute('aria-busy', busy);
    button.classList.toggle('is-loading', busy);
    if (busy) button.dataset.zxWasDisabled = button.disabled ? '1' : '';
    button.disabled = busy || button.dataset.zxWasDisabled === '1';
  };

  async function add(form, submitter) {
    const drawer = document.querySelector('cart-drawer');
    const body = new FormData(form);
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.append('sections', drawer.getSectionsToRender().map((s) => s.id).join(','));
      body.append('sections_url', window.location.pathname);
    }
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const res = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body,
    });
    const data = await res.json();
    if (!res.ok || data.status) {
      errorFor(form).textContent = data.description || data.message || window.cartStrings?.error || 'Could not add to cart.';
      return;
    }
    drawer.renderContents(data);
    if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'zx-cart', productVariantId: body.get('id'), cartData: data });
    }
    form.dispatchEvent(new CustomEvent('zx:cart:added', { bubbles: true, detail: data }));
  }

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-zx-cart')) return;
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function' || !window.fetch) return; // normal submit

    if (event.submitter && event.submitter.hasAttribute('data-zx-direct')) return; // Buy it now -> normal submit to checkout
    event.preventDefault();
    const button = event.submitter || form.querySelector('[type="submit"]');
    if (button && button.hasAttribute('aria-busy')) return;
    form.querySelector('.zx-cart-error')?.remove();
    setBusy(button, true);
    add(form, button)
      .catch(() => {
        form.removeAttribute('data-zx-cart');
        form.submit();
      })
      .finally(() => setBusy(button, false));
  });

  window.zxCart = { add };
})();
